module.exports = require("smpte-timecode");